import {ChatBotProps, tabContact, tabMessages, TForm} from "@/components/dialog/types";
import {profileIconRenderer} from "@/components/dialog/renderers";
import {Icon} from "@/components/Icon.tsx";
import React from "react";
import {contrastColor, hexToRGB} from "@/utils/colors";

const TabHome = ({chatbotProps, onTabChange} :{chatbotProps : ChatBotProps, onTabChange : any}) => {
    let rgb = hexToRGB(chatbotProps.design.profileIconBgColor);
    let headerContrastColor = contrastColor(rgb.r, rgb.g, rgb.b);

    return (
        <div className="h-full flex flex-col items-center justify-center z-10">
            {chatbotProps.design.tabHomeShowIcon &&
                profileIconRenderer(chatbotProps, 1.6)
            }

            <div id="tab-home-html" className=" my-10 px-3" dangerouslySetInnerHTML={{__html : chatbotProps.design.tabHomeHtml}}></div>

            <button type="button" className="btn btn inline-flex justify-center rounded-lg cursor-pointer hover:opacity-80 normal-case"
                    onClick={() => {onTabChange(tabContact)}}
                    style={{
                        backgroundColor : chatbotProps.design.profileIconBgColor,
                        color : headerContrastColor
                    }}
            >
                <Icon className="gialog-input-icon icon-default mr-2"  icon="fluent:person-circle-20-regular" width="25"/>
                <span className="flex items-center">Add your details</span>
            </button>

            <button type="button" className="btn btn inline-flex justify-center rounded-lg cursor-pointer hover:opacity-80 normal-case mt-6"
                    onClick={() => {onTabChange(tabMessages)}}
                    style={{
                        backgroundColor : chatbotProps.design.profileIconBgColor,
                        color : headerContrastColor
                    }}
            >
                <Icon className="gialog-input-icon icon-default mr-2"  icon="ph:chat-text" width="25"/>
                <span className="flex items-center">Start a conversation</span>
            </button>
        </div>
    )
}

export default TabHome